export const time = {
    "alert_time_out": "Thời gian làm bài đã hết",
    "hours": "giờ",
    "minute": "phút",
    "second": "giây",
    "time_worked": "Thời gian làm bài",
    "time": "Thời gian",
    "times": "lần",
};
